// The cloud JSON mirror (s3-sync.ts) may be waiting to retry a project's
// snapshot after a 429 quota refusal. That wait must end when the project is
// deleted or the operator signs out, or it fires later as a stray request for
// a job or a session that no longer exists. s3-sync.ts is loaded lazily after
// the first save, so the delete and sign-out paths raise this event instead of
// importing it; if s3-sync was never loaded, no retry is waiting.

export const CLOUD_MIRROR_RETRY_CANCEL_EVENT = 'qm-cloud-mirror-retry-cancel';

/** End waiting mirror retries: one project's when `projectId` is given, every project's otherwise (sign-out). */
export function requestCloudMirrorRetryCancel(projectId: string | null = null): void {
    try {
        window.dispatchEvent(new CustomEvent(CLOUD_MIRROR_RETRY_CANCEL_EVENT, { detail: { projectId } }));
    } catch {
        // No window (tests, workers): no mirror retry can be waiting there.
    }
}
